export default "__VITE_ASSET__1R6mgpGP__"